<select
  class="dropdown"
  name="pageSize"
  [(ngModel)]="selectedSize"
  (change)="onChange()">
  <option
    *ngFor="let pageSize of pageSizes"
    [value]="pageSize">
    <span>{{ pageSize }}</span>
  </option>
</select>
